import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from '@ui/Dropdown';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store';

interface FavoriteClub {
    id: number | undefined;
    title: string | undefined;
    slug: string | undefined;
    logo: string | undefined;
}

const FavoriteClubs = () => {
    const auth = useSelector((state: AppState) => state.auth);
    const router = useRouter();
    const favoriteClubs: FavoriteClub[] = auth.user?.favorite_clubs;

    const handleRedirectToClub = useCallback((slug: string) => {
        void router.push(`/club/${slug}`);
    }, []);

    return favoriteClubs?.length > 0 ? (
        <Dropdown size="md" placement="bottom-end" slim icon={<FontAwesomeIcon icon={faStar} />}>
            {favoriteClubs.map((item) => (
                <Dropdown.Item key={item.slug} label={item.title} onClick={() => handleRedirectToClub(item.slug)} />
            ))}
        </Dropdown>
    ) : null;
};

export default FavoriteClubs;
